/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VideosAnswerShortCompleted,
    VideosAnswerShortCompletedFromJSON,
    VideosAnswerShortCompletedFromJSONTyped,
    VideosAnswerShortCompletedToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProgramVideosAnswer
 */
export interface ProgramVideosAnswer {
    /**
     * 
     * @type {string}
     * @memberof ProgramVideosAnswer
     */
    programName?: string;
    /**
     * 
     * @type {Array<VideosAnswerShortCompleted>}
     * @memberof ProgramVideosAnswer
     */
    videos?: Array<VideosAnswerShortCompleted>;
}

export function ProgramVideosAnswerFromJSON(json: any): ProgramVideosAnswer {
    return ProgramVideosAnswerFromJSONTyped(json, false);
}

export function ProgramVideosAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramVideosAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programName': !exists(json, 'program-name') ? undefined : json['program-name'],
        'videos': !exists(json, 'videos') ? undefined : ((json['videos'] as Array<any>).map(VideosAnswerShortCompletedFromJSON)),
    };
}

export function ProgramVideosAnswerToJSON(value?: ProgramVideosAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program-name': value.programName,
        'videos': value.videos === undefined ? undefined : ((value.videos as Array<any>).map(VideosAnswerShortCompletedToJSON)),
    };
}


